/*
 * @Author: weiyanna weiyanna@jd.com
 * @Date: 2026-03-24 18:56:31
 * @LastEditors: weiyanna weiyanna@jd.com
 * @LastEditTime: 2026-03-25 17:06:16
 * @FilePath: /isp_International/src/dataPort/searchResultReport.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { reportSearchResultCountsExposure } from '@/dataPort/verticalSearchReport';
import { getUuid } from '@/util';
import { clearSearchRefreshReportId, getPvIdLogId, updatePvIdLogId } from '@/util/hooks/usePvId';

type SearchParams = Record<string, any>;
type SearchResponse = {
  success?: boolean;
  value?: {
    page?: Record<string, any>;
    mtest?: string;
  };
};

const getKeyword = (params: SearchParams = {}) => params?.key || params?.cat || '';

const getSearchResultReportData = (nextParams: SearchParams = {}, currentParams: SearchParams = {}) => {
  const storedReportData = getPvIdLogId();
  const hasCurrentParams = Object.keys(currentParams || {}).length > 0;

  if (!hasCurrentParams) {
    return storedReportData;
  }

  const currentKeyword = getKeyword(currentParams);
  const nextKeyword = getKeyword(nextParams);
  const keywordChanged = currentKeyword !== nextKeyword || (currentParams?.cat || '') !== (nextParams?.cat || '');

  if (keywordChanged) {
    return storedReportData;
  }

  const { pageNo: currentPageNo, ...currentOtherParams } = currentParams || {};
  const { pageNo: nextPageNo, ...nextOtherParams } = nextParams || {};
  const otherParamsChanged = JSON.stringify(currentOtherParams) !== JSON.stringify(nextOtherParams);
  const paramsChanged = JSON.stringify(currentParams || {}) !== JSON.stringify(nextParams || {});

  if (!otherParamsChanged && currentPageNo !== nextPageNo) {
    return updatePvIdLogId('page_turn');
  }

  if (paramsChanged) {
    return updatePvIdLogId('filter');
  }

  return storedReportData;
};

export const reportSearchResultCounts = ({
  params,
  currentParams,
  response,
  pin,
  reuseReportData = false,
  forcedReportId,
}: {
  params: SearchParams;
  currentParams?: SearchParams;
  response?: SearchResponse;
  pin?: string;
  reuseReportData?: boolean;
  forcedReportId?: string;
}) => {
  if (!response?.success) {
    return;
  }

  const pageInfo = response?.value?.page || {};
  const resultCounts = pageInfo?.maxResultCount ?? 0;
  const { pvId, logId } = reuseReportData ? getPvIdLogId() : getSearchResultReportData(params, currentParams);
  const hasForcedReportId = !!forcedReportId;
  const finalPvId = hasForcedReportId ? (forcedReportId as string) : pvId;
  const finalLogId = hasForcedReportId ? (forcedReportId as string) : logId;

  reportSearchResultCountsExposure({
    keyword: getKeyword(params),
    pin: pin || window.localStorage.getItem('PIN') || '',
    pvid: finalPvId,
    logid: finalLogId,
    uuid: getUuid(),
    timestamp: Date.now(),
    result_counts: resultCounts,
    page: pageInfo?.pageIndex ?? params?.pageNo ?? 1,
    ext: '',
    fold: '',
    mtest: response?.value?.mtest || '',
    mtest_act: '',
  });

  if (!hasForcedReportId) {
    clearSearchRefreshReportId();
  }
};
